import { LabelledStep, DashedConnector } from 'components';
import { useTranslation } from 'react-i18next';

/**
 * Return common props for signup stepper
 */
const useRegistrationStepperProps = () => {
  const { t } = useTranslation();

  return {
    onClick: () => {},
    steps: [
      {
        title: t('subscribe.enter_billing_info'),
      },
      {
        title: t('subscribe.complete_setup'),
      },
    ],
    connectorComponent: DashedConnector,
    stepComponent: LabelledStep,
  };
};

export default useRegistrationStepperProps;
